import React from 'react';
import { useParams } from 'react-router';

import { ResourceTypeDto } from '@/api/generated';
import { ResourceDetailsTimelineMessages } from '@/components/timelineMessages/ResourceDetailsTimelineMessages.comp.tsx';

export const ProcessDetailsMessagesTab: React.FC = () => {
  const { processId } = useParams();

  if (!processId) {
    return null;
  }

  return (
    <ResourceDetailsTimelineMessages
      resource={{ resourceId: processId, type: ResourceTypeDto.Process }}
    />
  );
};
